import { PagingParams, PagedResults } from '@abaco/web-common/src/Paging';
import { HTTPClient } from '@abaco/web-common/src/HTTP';
import { PlotGroup } from '../models/PlotGroup';

export default class PlotGroupApi {

    private http: HTTPClient;

    constructor(http: HTTPClient) {
        this.http = http;
    }

    async getPlotGroups(pkCuaa: number, paging: PagingParams): Promise<PagedResults<PlotGroup>> {
        const res = await this.http.get(`/sitiagri-rest-api/api_basic/v1/plots/subjects/${pkCuaa}/plot_groups`, {
            params: {
                offset: paging.offset,
                count: paging.count
            }
        });

        return res.data;
    }

    async getPlotGroup(plot_group_id: number): Promise<PlotGroup>{
        const res = await this.http.get(`/sitiagri-rest-api/api_basic/v1/plots/plot_groups/${plot_group_id}`);

        return res.data;
    }

    async editPlotGroup(plot_group_id: number, plot_group_name: string): Promise<PlotGroup>{
        const res = await this.http.put(`/sitiagri-rest-api/api_basic/v1/plots/plot_groups/${plot_group_id}`, {
            plot_group_name
        });

        return res.data;
    }

    async createPlotGroup(pk_cuaa: number, plot_group_name: string): Promise<PlotGroup>{
        const res = await this.http.post(`/sitiagri-rest-api/api_basic/v1/plots/subjects/${pk_cuaa}/plot_groups`,{
            plot_group_name
        });

        return res.data;
    }

    async addPlotsToGroup(plot_group_id: number, plotsIdToBeAdded: {plot_id: number}[]): Promise<{plot_id: number}[]> {
        const res = await this.http.post(`/sitiagri-rest-api/api_basic/v1/plots/plot_groups/${plot_group_id}/plots`, plotsIdToBeAdded);

        return res.data;
    }

    async removePlotsFromGroup(plot_group_id: number, plotsIdToBeRemoved: {plot_id: number}[]): Promise<{plot_id: number}[]> {
        const res = await this.http.delete(`/sitiagri-rest-api/api_basic/v1/plots/plot_groups/${plot_group_id}/plots`, {data: plotsIdToBeRemoved});

        return res.data;
    }

    async deletePlotGroup(plot_group_id: number): Promise<PlotGroup> {
        const res = await this.http.delete(`/sitiagri-rest-api/api_basic/v1/plots/plot_groups/${plot_group_id}`);

        return res.data;
    }

    async getPermit(ssoFunction: string): Promise<boolean> {
        const res = await this.http.get(`/sitiagri-rest-api/api_basic/v1/user_registry/sso_functions/SCHEDE/${ssoFunction}`);
        return res.data.result;
    }

}
